@if (data?.length > 0) {
  <div style="display: flex; flex-direction: column;" id="{{dataTableId}}">
    <div class="table-line">
      @if (selectable && selectAllEnabled) {
        <div class="form-check" style="padding-bottom: 10px;">
          <input type="checkbox"
            class="form-check-input"
            id="selectAll-{{dataTableId}}"
            [(ngModel)]="allSelected"
            (change)="toggleSelectAll($event)">
          <label class="form-check-label" for="selectAll-{{dataTableId}}"><span class="visually-hidden">Selecionar todos</span></label>
        </div>
      }
      @for (column of columns; track column) {
        <div [ngStyle]="column.style" class="label-column">
          <p class="table-column-header">{{column.title}}</p>
        </div>
      }
    </div>
    <div style="display: flex; flex-direction: column">
      @for (row of (paginated ? (data | paginate: { id: 'pagination', itemsPerPage: pagination.size, currentPage: pagination.page, totalItems: pagination.total}) : data); track row; let id = $index) {
        <div class="table-line">
          @if (selectable) {
            <div class="form-check" style="padding-bottom: 10px;">
              <input type="checkbox"
                class="form-check-input"
                id="checkboxPage{{dataTableId + (id + 1)}}"
                (change)="onSelectRow($event, row)"
                [(ngModel)]="row.checked">
              <label class="form-check-label" for="checkboxPage{{dataTableId + (id + 1)}}"><span class="visually-hidden">Selecione {{id + 1}}</span></label>
            </div>
          }
          @for (column of columns; track column) {
            <div [ngStyle]="column.style" style="flex-wrap: nowrap;">
              <p class="table-column-data">{{row[column.key]}}</p>
            </div>
          }
          <ng-container [ngTemplateOutlet]="columnDownload" [ngTemplateOutletContext]="{row: row}"></ng-container>
        </div>
      }
    </div>
  </div>
}
@if (paginated) {
  <div class="pagination-datatable">
    <div class="show-pagination">
      <span><p>Exibir</p></span>
      <app-select
        ngClass="form-control-selecao select-items"
        [value]="pagination.size"
        (valueChanges)="onPerPageChange($event)"
        id="itemsPerPage"
      [options]="[
                  {name : '5 REGISTROS' , value : '5'} ,
                  {name : '10 REGISTROS' , value : '10'},
                  {name : '15 REGISTROS' , value : '15'},
                  {name : '20 REGISTROS' , value : '20'}
                  ]"
        optionValue="value"
        optionText="name">
      </app-select>
      <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
      <span><p> por página</p></span>
    </div>
    <div class="pagination-center-padding">
      <pagination-controls id="pagination" class="itens-pagina" (pageChange)="onPageChange($event)"
        directionLinks="false" autoHide="false"
        responsive="true" previousLabel="" nextLabel=""
        screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
        screenReaderCurrentLabel="Página">
      </pagination-controls>
    </div>
    <div class="pagination-right-padding">
      <span class="subtitle-table"><p><b style="font-weight: 600">{{pagination.total}}</b> Registros foram encontrados</p></span>
    </div>
  </div>
}
<ng-template #columnDownload let-row="row">
  @if (downloadable) {
    <div class="table-download-column">
      <button class="btn pt-0" id="btnDownload" (click)="downloadSelected(row)" style="color: #008060; margin-bottom: 2px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 33 33" fill="none" style="margin-bottom: 2px;">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.65413 20.6238C5.39051 20.6238 5.98747 21.2207 5.98747 21.9571V24.6238C5.98747 26.0965 7.18138 27.2904 8.65413 27.2904H24.6541C26.1269 27.2904 27.3208 26.0965 27.3208 24.6238V21.9571C27.3208 21.2207 27.9178 20.6238 28.6541 20.6238C29.3905 20.6238 29.9875 21.2207 29.9875 21.9571V24.6238C29.9875 27.5693 27.5997 29.9571 24.6541 29.9571H8.65413C5.70862 29.9571 3.3208 27.5693 3.3208 24.6238V21.9571C3.3208 21.2207 3.91775 20.6238 4.65413 20.6238Z" fill="#008060"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6541 21.9572C15.9178 21.9572 15.3208 21.3602 15.3208 20.6238L15.3208 4.62382C15.3208 3.88744 15.9178 3.29049 16.6541 3.29049C17.3905 3.29049 17.9875 3.88744 17.9875 4.62382L17.9875 20.6238C17.9875 21.3602 17.3905 21.9572 16.6541 21.9572Z" fill="#008060"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.04482 13.0143C8.52412 13.535 8.52412 14.3792 9.04482 14.8999L15.7115 21.5666C16.2322 22.0873 17.0764 22.0873 17.5971 21.5666L24.2638 14.8999C24.7845 14.3792 24.7845 13.535 24.2638 13.0143C23.7431 12.4936 22.8989 12.4936 22.3782 13.0143L16.6543 18.7382L10.9304 13.0143C10.4097 12.4936 9.56552 12.4936 9.04482 13.0143Z" fill="#008060"/>
        </svg>
        <span style="text-decoration: underline; margin-left: 8px; margin-top: 5px;">BAIXAR</span>
      </button>
    </div>
  }
</ng-template>


